export default __webpack_public_path__ + "static/media/korea-flag.1a2ff967.png";